import React, { useEffect } from 'react';
import { AdMobService } from '../services/admob';

interface BannerAdProps {
  autoShow?: boolean;
  adId?: string;
  isTesting?: boolean;
}

/**
 * A reusable Banner Ad component that manages its own lifecycle
 */
const BannerAd: React.FC<BannerAdProps> = ({ autoShow = true, adId, isTesting }) => {
  useEffect(() => {
    const refreshAd = async () => {
      if (autoShow) {
        await AdMobService.hideBanner().catch(() => {});
        await AdMobService.showBanner().catch(() => {});
      }
    };

    refreshAd();

    // Cleanup: Remove banner when component unmounts
    return () => {
      AdMobService.hideBanner().catch(() => {});
    };
  }, [autoShow, adId, isTesting]);

  return null; // Banner ads are rendered as an overlay on the Capacitor webview
};

export default BannerAd;
